import * as React from 'react';
import { Component } from 'react';
import { FileUploadComponent } from '../../controls/FileUpload';
import { IUserFile } from '../../models/IUserFile';
import { UserFileService } from '../../services/UserFileService';
//import { ImageModalComponent } from '../../controls/ImageModal';
const ImageModalComponent = React.lazy(() => import('../../controls/ImageModal'));


interface IProps {
    IsEditMode: boolean,
    Certifications: IUserFile[],
    OnRefreshRequired: () => void
}

interface IState {
    ShowAddAttachment: boolean,
    ImageModalVisible: boolean,
    ModalFile?: IUserFile,
    ShowAll: boolean
}

export class CertificationsComponent extends Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            ShowAddAttachment: false,
            ImageModalVisible: false,
            ShowAll: false
        }

        this.AddAttachment = this.AddAttachment.bind(this);
        this.AbortAdd = this.AbortAdd.bind(this);
        this.OnAttachmentAdd = this.OnAttachmentAdd.bind(this);
        this.OnDeleteSuccess = this.OnDeleteSuccess.bind(this);
        this.OnDeleteError = this.OnDeleteError.bind(this);
        this.OpenImageModal = this.OpenImageModal.bind(this);
        this.CloseModal = this.CloseModal.bind(this);
        this.PrevFile = this.PrevFile.bind(this);
        this.NextFile = this.NextFile.bind(this);
        this.OnProcessSuccess = this.OnProcessSuccess.bind(this);
        this.OnProcessError = this.OnProcessError.bind(this);
        this.ShowMore = this.ShowMore.bind(this);
    }

    public render() {
        let itemsElement: null | JSX.Element = null;
        let buttons: null | JSX.Element = null;
        if (this.state.ShowAddAttachment) {
            buttons = (
                <div className="buttons">
                    <button className="std-secondary-btn" onClick={this.AbortAdd}>Anuluj</button>
                </div>
            );
            itemsElement = (
                <div className="input">
                    <FileUploadComponent
                        OnFileUploaded={this.OnAttachmentAdd}
                        UploadUrl="api/userfile/uploadmycertifications"
                        FileTypes="image/jpeg, image/png, application/pdf" />
                    {buttons}
                </div>
            );
        } else {
            let certifications: null | IUserFile[];
            if (this.state.ShowAll) {
                certifications = this.props.Certifications;
            } else {
                certifications = this.props.Certifications.filter((i, index) => (index < 4))
            }
            let listItems = certifications.map((c) => (
                <li key={c.Id}
                    onClick={this.OpenImageModal.bind(this, c)}
                    style={{
                        backgroundImage: c.ContentType === 'application/pdf' ?
                            'url("/images/pdf.svg")' :
                            'url("' + c.Path + '")',
                        backgroundColor: c.ContentType === 'application/pdf' ?
                            'rgba(255,255,255,0)' :
                            'rgb(231,233,237)'
                    }}>
                    {
                        this.props.IsEditMode ?
                            (<span className="delete-btn" onClick={this.DeteleFile.bind(this, c.Id)}>&nbsp;</span>) :
                            null
                    }
                </li>
            ));
            let showMoreElement: null | JSX.Element = null;
            if (this.props.Certifications.length > 4 && this.state.ShowAll === false) {
                showMoreElement = (
                    <li key={0} onClick={this.ShowMore} className="show-more">
                        {'+ ' + (this.props.Certifications.length - 4).toString()}
                    </li>
                );
            }
            let addElement: null | JSX.Element = null;
            if (this.props.IsEditMode) {
                addElement = (
                    <li key={-1} onClick={this.AddAttachment} className="add-btn">
                        <span>Dodaj</span>
                    </li>
                );
            }
            itemsElement = (
                <div className="input images-list">
                    <ul className="attachment-list">
                        {listItems}
                        {showMoreElement}
                        {addElement}
                    </ul>
                    {buttons}
                </div>
            );
        }
        return (
            <div className="form-row columns">
                <label>Certyfikaty:</label>
                {itemsElement}
                <React.Suspense fallback={<div>Loading...</div>}>
                    <ImageModalComponent
                        OnCloseClick={this.CloseModal}
                        Visible={this.state.ImageModalVisible}
                        File={this.state.ModalFile}
                        OnPrevClick={this.PrevFile}
                        OnNextClick={this.NextFile} />
                </React.Suspense>
            </div>
        );
    }//end-of-render

    private AddAttachment(evt) {
        this.setState({
            ShowAddAttachment: true
        });
    }

    private AbortAdd(evt) {
        this.setState({
            ShowAddAttachment: false
        });
    }

    private OnAttachmentAdd(result) {
        let service = new UserFileService();
        service.ProcessImages(result.data.Value as number[], this.OnProcessSuccess, this.OnProcessError);
        this.setState({
            ShowAddAttachment: false
        });
        this.props.OnRefreshRequired();
    }

    private OnProcessSuccess(result) {

    }

    private OnProcessError(error) {
        console.error(error);
    }

    private DeteleFile(fileId: number, evt) {
        let service = new UserFileService();
        service.DeleteMyFile(fileId, this.OnDeleteSuccess, this.OnDeleteError);
        evt.stopPropagation();
    }

    private OnDeleteSuccess(result) {
        this.props.OnRefreshRequired();
    }

    private OnDeleteError(error) {
        console.error(error);
    }

    private OpenImageModal(file: IUserFile, evt) {
        this.setState({
            ImageModalVisible: true,
            ModalFile: file
        });
    }

    private CloseModal() {
        this.setState({
            ImageModalVisible: false
        });
    }

    private PrevFile() {
        if (this.state.ModalFile) {
            let currentFileIndex = this.props.Certifications.indexOf(this.state.ModalFile);
            let totalFilesCount = this.props.Certifications.length;
            let prevFileIndex = (currentFileIndex - 1 + totalFilesCount) % totalFilesCount;
            this.setState({
                ModalFile: this.props.Certifications[prevFileIndex]
            });
        }
    }

    private NextFile() {
        if (this.state.ModalFile) {
            let currentFileIndex = this.props.Certifications.indexOf(this.state.ModalFile);
            let totalFilesCount = this.props.Certifications.length;
            let nextFileIndex = (currentFileIndex + 1) % totalFilesCount;
            this.setState({
                ModalFile: this.props.Certifications[nextFileIndex]
            });
        }
    }

    private ShowMore(evt) {
        this.setState({
            ShowAll: true
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/PhysiotherapistView/Certifications.tsx